import { titulosApi } from "../view/titulos.service";
import { reshape_response } from "../../../../helpers/functions";

export const getTituloById = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    getTituloById: builder.query({
      query: (id) => ({
        url: `/v1/api/titulo/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Titulos", id }],
      transformResponse: (response, meta, args) => {
        // Si hay un args.shape, usamos reshape_response, si no, lo devolvemos tal cual
        return args?.shape ? reshape_response(response, args.shape) : response;
      },
    }),
  }),
});

export const { useGetTituloByIdQuery } = getTituloById;
